import angular from 'angular';
import controller from './mf.controller';
import template from './mf.html';
import MfComponent from './mf.component';

const mfConfig = /* @ngInject */ (/** @type {any} */ KformComponentsProvider) => {
	KformComponentsProvider.register('mf', {
		title:                      'MF Field',
		template,
		icon:                       'fa fa-magic',
		tableView:                  (/** @type {any} */ data) => (data ? data.name : ''),
		onEdit:     /* @ngInject */ (
			/** @type {any} */ $scope,
			/** @type {any} */ MethodService,
			/** @type {import('angular').translate.ITranslateService} */ $translate,
			/** @type {any} */ Notification,
		) => {
			$scope.methods = MethodService.methods;
			$scope.colGetId = (/** @type {any} */ col) => {
				let returnValue;

				if (angular.isObject(col) && 'kid' in col) {
					returnValue = col.kid;
					if (col.linker_kid !== '0') {
						returnValue += `|${col.linker_kid}`;
					}
				}
				return returnValue;
			};

			$scope.colGetKey = (
				/** @type {any} */ col,
			) => ($scope.component || $scope.$parent.component).ktable.cols.findIndex(
				(/** @type {any} */ c) => c.kid === col.kid && c.linker_kid === col.linker_kid,
			);

			$scope.colGetName = (/** @type {any} */ col) => {
				let returnValue = col.name;

				if (col.linker_kid !== '0') {
					returnValue += ` :: ${col.linker_info.name}`;
				}

				return returnValue;
			};

			$scope.hasColRepre = () => {
				let returnValue = false;

				const component = $scope.component || $scope.$parent.component;
				if (component.kdata.mf_order) {
					for (const c of component.ktable.cols) {
						if (c.kid === component.kdata.mf_order) {
							returnValue = true;
						}
					}
				}

				return returnValue;
			};

			$scope.jsonEditorOptions = {
				mode:        'code',
				modes:       [],
				mainMenuBar: false,
				onError:     (/** @type {any} */ error) => {
					Notification.warning({
						title:   $translate.instant('error.title'),
						message: error.toString(),
					});
				},
				statusBar:   false,
			};

			$scope.toggleSelection = (/** @type {any} */ col) => {
				const index = $scope.colGetKey(col);
				const component = $scope.component || $scope.$parent.component;

				if (index >= 0) {
					component.ktable.cols.splice(index, 1);
				}
				else {
					component.ktable.cols.push(col);
				}
			};

			$scope.tmpDefaultValue = angular.copy($scope.component.defaultValue);

			$scope.$watch('tmpDefaultValue', () => {
				$scope.component.defaultValue = $scope.tmpDefaultValue.map((/** @type {any} */ v) => ({
					kid:  v.kid,
					name: v.name,
				}));
			}, true);

			$scope.definedby = [];
		},
		children:                   false,
		selectable:                 true,
		settings:                   new MfComponent(),
		views:                      [
			{
				name:     'Display',
				template: 'kform/components/mf/display.html',
			},
			{
				name:     'Data',
				template: 'kform/components/mf/data.html',
			},
			{
				name:     'Table',
				template: 'kform/components/mf/ktable.html',
			},
			{
				name:     'Validation',
				template: 'kform/components/common/validate.html',
			},
			{
				name:     'API',
				template: 'kform/components/common/api.html',
			},
			{
				name:     'Layout',
				template: 'kform/components/common/layout.html',
			},
			{
				name:     'Conditional',
				template: 'kform/components/common/conditional.html',
			},
			{
				name:     'Events',
				template: 'kform/components/common/events.html',
			},
		],
		controller,
	});
};

export default angular.module('app')
	.config(mfConfig);
